<template>
  <div class="content">
    <div class="content__row">
      <div class="content__column content__column--wide">
        <h1 class="content__title">Páginas</h1>
      </div>
    </div>
    <div class="content__row">
      <page-list :filters="filters"></page-list>
      <page-view :page="page" v-if="pageAction === 'view' && page"></page-view>
      <page-edit @new="newPAge" :page="page" v-if="pageAction === 'edit'" :key="key"></page-edit>
      <div class="content__column content__column--small">
        <h1 class="content__title">Opciones</h1>
        <div class="information">
          <h2 class="content__subtitle">Filtro</h2>
          <div class="form__container">
            <label for="search" class="form__label">búsqueda Libre</label>
            <input type="text" name="search" id="search" class="form__input" v-model="search" @keyup="setFilters">
          </div>
          <div class="form__container">
          <label class="form__label form__label--required" for="status_id">Filtrar por estatus</label>
          <div class="form__select-container">
            <select name="status_id" id="status_id" class="form__select" v-model="status_id" @change="setFilters">
              <option hidden :value="null">Selecciona un estatus</option>
              <option v-for="(status, index) in page_status" :key="index" :value="status.id" v-text="status.name"></option>
            </select>
          </div>
        </div>
        </div>
      </div>
    </div>
    <button @click.prevent="newPAge" class="btn btn__add">Agregar</button>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import pageList from './list'
import pageView from './view'
import pageEdit from './edit'
import Mixins from './mixins'
import {page_status} from './mocks'
export default {
  mixins: [
    httpService,
    Mixins
  ],
  components: {
    pageList,
    pageView,
    pageEdit
  },
  data: function () {
    return {
      page_status: page_status,
      key: 0,
      search: null,
      status_id: null,
      filters: undefined,
      pageAction: null,
      page: null
    }
  },
  mounted: function () {
    this.$on('view',id => {
      this.getPage(id, 'view')
    })
    this.$on('edit',id => {
      this.getPage(id, 'edit')
    })
  },
  methods: {
    setFilters: function () {
      let filter = ''
      if (this.search && this.search.length > 1) {
        filter = filter + '&search=' + this.search
      }
      if (this.status_id) {
        filter = filter + '&status_id=eq:' + this.status_id
      }
      filter = filter.replace(/(^&+|&+$)/, '')
      if (filter.length > 0) {
        this.filters = filter
      } else {
        this.filters = undefined
      }
    },
    getPage: function (id, action) {
      this.pageAction = action
      let httpRequest = {
        params: '',
        module: 'pages'
      }
      this.getById(id, httpRequest)
        .then(
          page => {
            this.page = page.data
          }
        )
    },
    newPAge: function () {
      this.page = undefined
      this.key = ++this.key
      this.pageAction = 'edit'
    }
  }
}
</script>

<style lang="sass">
  @import "../../assets/sass/components/_home"
  @import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/pages/pages.vue